import React from "react";
import { smallImageUrl, thumbUrl } from "../../../components/aotd-gallery/galleryImages";
import type { AotdDay } from "../printsApi";
import type { PrintEdition, PrintFormat } from "../printProducts";
import { CardFace } from "./faces/CardFace";
import { SheetFace } from "./faces/SheetFace";
import "./printShowcase.css";

// A print face on its own, flat and small: what a pre-order will be, without a scene around it.

export const PrintFaceThumb: React.FC<{ day: AotdDay; format: PrintFormat; edition: PrintEdition; width: number }> = ({
  day,
  format,
  edition,
  width,
}) => {
  if (format === "trading-card") {
    return (
      <div className="pft pft-card">
        <CardFace day={day} art={thumbUrl(day.filename)} edition={edition} mm={width / 63} />
      </div>
    );
  }
  return (
    <div className="pft pft-sheet">
      <SheetFace day={day} art={width > 300 ? smallImageUrl(day.filename) : thumbUrl(day.filename)} size={format === "poster" ? 50 : 21} edition={edition} width={width} />
    </div>
  );
};

export default PrintFaceThumb;
